<svg:g>
	<rect *ngFor="let r of getRects()" [attr.x]="r.x" [attr.y]="r.y" [attr.height]="r.h" [attr.width]="r.w"
		fill="white" stroke="lightgray" stroke-width="1"></rect>
	<circle *ngIf="out" [attr.cx]="out.x" [attr.cy]="out.y" [attr.r]="out.r" 
		[attr.fill]="cover ? 'lightblue' : 'white'" stroke="black"></circle>
</svg:g>
